import { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { type AppState, selectLocationPathname } from '@cobliteam/store';

import NavbarDashboardContainer from '../../components/NavbarDashboard';

import LoadingPage from '../../pages/LoadingPage';

const SetupLayout = ({ children }: any) => {
  const currentLocation = useSelector((state: AppState) =>
    selectLocationPathname(state)
  );
  if (!currentLocation.includes('onboarding')) return null;

  return (
    <Suspense
      fallback={<LoadingPage message='Carregando Guia de implementação...' />}
    >
      <div>
        <NavbarDashboardContainer />
        {children}
      </div>
    </Suspense>
  );
};

export default SetupLayout;
